import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { sortTranslated } from "../shared/util";
import Storage from "../../session/storage";
import EmployerConfig from "../../config/EmployerPopupConfig.json";

const EmployerInput = (props) => {

    const { formConfig, updatedValue } = props
    const [error, setError] = useState(false);
    const [invalidInputFlag, setInvalidInputFlag] = useState(false)
    const [value, setValue] = useState(props.value || '');
    const [label, setLabel] = useState(props.label || '');
    const [flag, setFlag] = useState(false);
    const [mainInfoData] = useState(formConfig.find((el) => {
        return el.id === 'mainInfo'
    }));
    const [contactdata] = useState(formConfig.find((el) => {
        return el.id === 'contactInfo'
    }));

    const getOptionKey = (name) => {
        switch (name) {
            case 'Classification Code':
                return 'Classification';
            case 'Identifiers Type':
                return 'AltIDType';
            case 'Identifiers Sub Type':
                return 'AltIDSubtype';
            case 'State Province':
                return 'StateProvince';
            case 'Country':
                return 'Country';
            case 'Country Code':
                return 'Country'
            default:
                return name;
        }
    }

    const getOptionsForEmployer = (name) => {
        switch (name){
            case 'Country':
                return EmployerConfig?.lov_config?.Country;
            case 'Classification':
                return EmployerConfig?.lov_config?.Classification?.[props?.lovKey] || [];
            case 'Contact Title':
                return EmployerConfig?.lov_config?.ContactTitle?.[props?.lovKey] || [];
            default:
                return []
        }
    }

    let options = Storage.getLovBoundedList() ? Storage.getLovBoundedList()?.[`${props.entity}`] : Storage.getPickList()?.[`${props.entity}_Emp`];
    let option;
    if (EmployerConfig.config_based_lov_attributes.includes(props.label.trim())) {
        option =  getOptionsForEmployer(getOptionKey(label.trim()))
    } else {
        option = options?.[getOptionKey(props.label.trim())]
    }

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    useEffect(() => {
        setLabel(props.label)
    }, [props.label])

    useEffect(() => {
        let flag = (value === null) || (value !== null && value !== undefined && value.length === 0);
        flag = (props.error && flag)
        setFlag(flag);
        if (props.clear && option === undefined) {
            setValue('')
        } else if (props.clear && option !== undefined) {
            setValue(null)
        }
    }, [props.clear, option, props.error, value, label])

    const handleInput = (event, passTo) => {
        mainInfoData?.attributes?.map((el) => {
            if (event.target.name === el.name && el.pattern) {
                if(!event.target.value){
                    setInvalidInputFlag(false)
                    const updatedInvalidInput = { ...props.invalidInput };
                    delete updatedInvalidInput?.[event.target.name];
                    props?.setInvalidInput(updatedInvalidInput);
                }else if (event.target.value.match(el.pattern.includes('+') ? el.pattern.replace('+', "\\s") : el.pattern)){
                    setInvalidInputFlag(false)
                    const updatedInvalidInput = { ...props.invalidInput };
                    delete updatedInvalidInput?.[event.target.name];
                    props?.setInvalidInput(updatedInvalidInput);
                }
                else {
                    setInvalidInputFlag(true)
                    props?.setInvalidInput({ ...props.invalidInput, [event.target.name]: true })
                }
            }
            return ({})
        })

        contactdata?.attributes?.map((el) => {
            if (event.target.name === el.name && (el.pattern)) {
                if(!event.target.value){
                    setInvalidInputFlag(false)
                    const updatedInvalidInput = { ...props.invalidInput };
                    delete updatedInvalidInput?.[event.target.name];
                    props?.setInvalidInput(updatedInvalidInput);
                }else if (event.target.value.match(el.pattern)){
                    setInvalidInputFlag(false)
                    const updatedInvalidInput = { ...props.invalidInput };
                    delete updatedInvalidInput?.[event.target.name];
                    props?.setInvalidInput(updatedInvalidInput);
                }
                else{
                    setInvalidInputFlag(true)
                    props?.setInvalidInput({ ...props.invalidInput, [event.target.name]: true })
                }
            }
            return ({})
        })

        setError(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))
        setValue(event.target.value)

        if (passTo) {
            passToParent(event)
        }
    }

    const passToParent = async (event) => {
        setError(event.target.value === null || (event.target.value !== null && event.target.value.length === 0));
        await setValue(event.target.value)
        props.updatedValue({ value: event.target.value === null ? '' : event.target.value }, props.required && (event.target.value === null || (event.target.value !== null && event.target.value.length === 0)))
    }

    const filter = createFilterOptions();

    const renderComponent = () => {
        switch (props?.type) {
            case 'input':
                return (
                    <TextField
                        type={props.type}
                        key={props.label}
                        error={(error && props.required) || invalidInputFlag}
                        helperText={((error && props.required) || invalidInputFlag) ? <span id="input-text">Please Enter Valid Input</span> : " "}
                        value={(value || '')}
                        onChange={handleInput}
                        onBlur={passToParent}
                        id={props.label}
                        name={props.label}
                        variant="standard"
                        color="primary" className="w-100 input-text" />
                );
            case 'select':
                return (
                    <Autocomplete
                        value={value === null ? [] : value}
                        key={props.label}
                        onChange={(event, value) => handleInput({ target: { value: value?.split(" | ")[0] } }, true)}
                        options={option?.length ? sortTranslated(option) : []}
                        getOptionLabel={(option) => option}
                        isOptionEqualToValue={(option, value) => option === value}
                        id={props.label}
                        name={props.label}
                        multiple={false}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                error={error && props.required}
                                variant="standard"
                                id="varantOptionTxT"
                                helperText={(error && props.required) ? "Please Select One Option" : " "} />}
                    />
                );
            case 'selectandtext':
                return (
                    <Autocomplete
                        freeSolo
                        value={value === null ? [] : value}
                        key={props.label}
                        onChange={(event, newValue) => {
                            console.log(newValue, "newValue")
                            if (typeof newValue === 'string') {
                               handleInput({ target: { value: newValue } }, true)
                            } else if (newValue && newValue.inputValue) {
                               handleInput({ target: { value: newValue.inputValue } }, true)
                            } else {
                                 handleInput({ target: { value: newValue?.split(" | ")?.[0] || '' } }, true)
                            }
                        }}
                        options={option?.length ? sortTranslated(option) : []}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, params);

                            const { inputValue } = params;
                            const isExisting = options.some((option) => inputValue === option);
                            if (inputValue !== '' && !isExisting) {
                            filtered.push(
                                inputValue,
                            );
                            }

                            return filtered;
                        }}
                        getOptionLabel={(option) => {
                            if (typeof option === 'string') {
                            return option;
                            }
                            if (option.inputValue) {
                            return option.inputValue;
                            }
                            // Regular option
                            return option;
                        }}
                        isOptionEqualToValue={(option, value) => option === value}
                        id={props.label}
                        name={props.label}
                        multiple={false}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                error={error && props.required}
                                variant="standard"
                                id="varantOptionTxT"
                                helperText={(error && props.required) ? "Please Select One Option" : " "} />}
                    />
                )
            default:
                return null;
        }
    }

    return (
        <div className="employer-input">
            {renderComponent()}
        </div>
    )
}

export default EmployerInput;